var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navigation'),_c('HelloWorld'),_c('Welcome'),_c('AboutMe'),_c('Experience'),_c('Skills'),_c('Projects'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }